module.exports = __webpack_public_path__ + "static/love-6900abf722b43c5fa7cbd85966f36abf.jpg";